<template>
  <div>
    <!-- 运行日汇总 -->
    <!-- 查询 -->
    <div style="display:flex;align-items: center; text-align:right">
      <summaryLevel @getLevel="getLevel" style="flex:1;margin-right:8px" :DealOptions="DealOptions" :mulSelectLoading="mulSelectLoading"></summaryLevel>
      <quickQuery  :isMounted="true" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" style="text-align: right"></quickQuery>
    </div>
    <!-- 表格 -->
    <div  class="page_container_a">
      <!-- <div class="page_table"> -->
        <el-table class="page_table" :id="'table'+queryType"
          :data="list" 
          :size="size" 
          border 
          :span-method="objectSpanMethod" 
          :show-summary="showSum" 
          :summary-method="getSummaries"
          v-loading="loading"
        >
          <!-- @sort-change='sortChange' sortable="custom"  -->
          <el-table-column label="汇总单元名称" align="center" min-width="150" prop="groupName" fixed="left"  class-name="fixd"></el-table-column>
          <el-table-column label="统计日期" align="center" min-width="120" prop="statDate" fixed="left"  class-name="fixd" v-if="queryType != 2"></el-table-column>
          <el-table-column label="运行时长(小时)" align="center" min-width="120" prop="runduration">
            <template slot-scope="scope">{{fixed2(scope.row.runduration)}}</template>
          </el-table-column>
          <el-table-column label="驾驶时长(小时)" align="center" min-width="120" prop="driveDuration">
            <template slot-scope="scope">{{fixed2(scope.row.driveDuration)}}</template>
          </el-table-column>
          <el-table-column label="怠速时长(小时)" align="center" min-width="120" prop="idleDuration">
            <template slot-scope="scope">{{fixed2(scope.row.idleDuration)}}</template>
          </el-table-column>
          <el-table-column label="怠速里程(公里)" align="center" min-width="120" prop="idleMileage"></el-table-column>
          <el-table-column label="怠速油耗(升)" align="center" min-width="120" prop="idleOilConsume"></el-table-column>
          <el-table-column label="运行里程(公里)" align="center" min-width="120" prop="runMileage">
            <template slot-scope="scope">{{fixed2(scope.row.runMileage)}}</template>
          </el-table-column>
          <el-table-column label="百公里油耗(升/百公里)" min-width="150" align="center" prop="perOilConsume"></el-table-column>
          <el-table-column label="燃油消耗(升)" align="center" min-width="120" prop="oilConsume"></el-table-column>
          <el-table-column label="耗电量(度)" align="center" min-width="110" prop="elecConsume"></el-table-column>
          <el-table-column label="百公里耗电量" align="center" min-width="120" prop="perElecConsume">
            <template slot-scope="scope">{{fixed2(scope.row.perElecConsume)}}</template>
          </el-table-column>
          
        </el-table>
      <!-- </div> -->
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import summaryLevel from '@/views/statistics/operationalData/components/summaryLevel'
import { mapState } from "vuex";
export default {
  props:{
    size:{
      type:String,
    },
    DealOptions:{
      type:Array,
      default:function () {
        return [] 
      }
    },
    mulSelectLoading:{
      type:Boolean,
      default:false,
    },
    queryType:{
      type:Number,
      default:0,
    }
  },
  components:{summaryLevel,quickQuery},
  data(){
    return{
      vehicles:"",
      loading:false,
      dataList:[],
      tableWidth:undefined,
      total:0,
      pageSize:10,
      currentPage:1,
      showSum:true,
      level:0,
      selectLevel:"",
      form:undefined,
      needMergeArr: ["groupName", "statDate"], 
      rowMergeArrs: [],
    }
  },
  computed:{
    list(){
      if(this.dataList != null && this.dataList.length > 0){
        return this.dataList.slice((this.currentPage - 1) * this.pageSize,this.currentPage * this.pageSize)
      }
      return [];
    },
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {
    // 合并合计行的合计
    dataList: {// 表格数据
      immediate: true,
      handler() {
        setTimeout(() => {
          // const tds = document.querySelectorAll('#table .el-table__footer-wrapper tr>td');//表格没有固定列时 写法
          const tds = document.querySelectorAll('#table1 .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
          console.log(tds);
          if(tds.length > 0){
            tds[23].colSpan = 2;
            tds[23].style.textAlign = 'center'
            tds[23].style.background = '#E8F0FF'
            tds[24].style.display = 'none'
          }
        }, 0)
      }
    },
    total(newVal){
      this.showSum = newVal > 1 ? true : false;
    },
    list:{
      immediate: true,
      handler() {
        this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.list); 
      }
    }
  },
  methods:{
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      if(Number.isInteger(val)) return val;
      return val.toFixed(2)
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    getList(){
      this.loading = true;
      this.$api.summaryInfo({
        vehicles: "",
        queryType: this.queryType,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        level: this.selectLevel,
        OperatorID: this.operator.OperatorId + "",
        OperatorID: 1668 + "",
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
      })
    },
    // 分页
    pageChange(page) {
      this.currentPage = page;
    },
    // 排序
    sortChange(column){
      // console.log("排序", column.prop, column.order);
      // this.currentPage = 1; // 排序后返回第一页
      this.dataList = this.dataList.sort(
        this.SortFun(column.prop, column.order === "descending")
      );
    },
    SortFun(attr, rev) {
      // console.log(rev)
      //第一个参数传入的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
        //rev = rev>0 ? 1 : -1;
      }
      return function (a, b) {
        a = a[attr];
        b = b[attr];
        // console.log(a,b);
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },

    // 合计行计算全部数据而不是当页合计
    getSummaries(param){
      let data = this.dataList;

      // console.log(param);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '小结';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        if(!Number.isInteger(sums[index])){
          sums[index] = sums[index].toFixed(2);
        }
      });

      return sums;
      
    
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      if (columnIndex === 0) {
        if (rowIndex % this.dataList.length === 0) {
          return {
            rowspan: this.dataList.length,
            colspan: 1
          };
        }else {
            return {
              rowspan: 0,
              colspan: 0
            };
        }
      }
    },
    getLevel(level){
      // console.log(level,"----------------------");
      this.level = level;
      if(this.level.isFirst){  // 汇总级别初始化完成时，查询数据。
        this.handleQuery(this.form);
      }
    },
    quickQuery(){},
    handleQuery(val){
      this.form = val;
      if(this.level.isAll){
        this.level.mulSelecteds.shift();
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else if(Array.isArray(this.level.mulSelecteds)){
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else{
        this.selectLevel = this.level.mulSelecteds;
      }
      // console.log(this.selectLevel);
      this.vehicles = this.getSelectedVehicles();
      if(this.selectLevel){  // 汇总级别有数据时，进行数据查询。
        this.getList();
      }
    },
    download(){
      console.log("导出");
    },


    //合并列
    rowMergeHandle(arr, data) {
      if (!Array.isArray(arr) && !arr.length) return false;
      if (!Array.isArray(data) && !data.length) return false;
      let needMerge = {};
      arr.forEach((i, idx) => {
        needMerge[i] = {
          rowArr: [],
          rowMergeNum: 0,
        };
        if (idx == 0) {
          data.forEach((item, index) => {
            // 表格首个数据单独处理
            if (index === 0) {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = 0;
            } else {
              if (item[i] === data[index - 1][i]) {
                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                needMerge[i].rowArr.push(0);
              } else {
                needMerge[i].rowArr.push(1);
                needMerge[i].rowMergeNum = index;
              }
            }
          });
        } else {
          let firstRowArr = needMerge[arr[0]].rowArr;
          let firstRowArrDeal = [];
          firstRowArr.forEach((item, index) => {
            if (item > 0) {
              firstRowArrDeal.push(index);
            }
          });
          data.forEach((item, index) => {
            let sign = false;
            if (firstRowArrDeal.indexOf(index) > 0) {
              needMerge[i].rowMergeNum = index;
              sign = true;
            }
            // 表格首个数据单独处理
            if (index === 0) {
              needMerge[i].rowArr.push(1);
              needMerge[i].rowMergeNum = 0;
            } else {
              if (item[i] === data[index - 1][i]) {
                if (sign) {
                  needMerge[i].rowArr.push(1);
                } else {
                  needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                  needMerge[i].rowArr.push(0);
                }
              } else {
                needMerge[i].rowArr.push(1);
                needMerge[i].rowMergeNum = index;
              }
            }
          });
        }
      });
      return needMerge;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      for(let res in this.needMergeArr){
          if(this.needMergeArr[res] == column.property){
              return this.mergeAction(column.property, rowIndex, columnIndex);
          }
      }
    },
    mergeAction(val, rowIndex) {
      let _row = this.rowMergeArrs[val].rowArr[rowIndex];
      let _col = _row > 0 ? 1 : 0;
      return [_row, _col];
    },
  },
  mounted(){
    this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.dataList); 
    
    // this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, this.list); 
    // this.getList();
  }

}
</script>

<style lang="scss" scoped>
.page_container_a {
    margin-top: 10px;

    ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
::v-deep .el-table {
  .el-table__body-wrapper {
    z-index: 1;
  }
}

// 解决列表加入固定出现底部白条问题
::v-deep .el-table__fixed {
  height: 100% !important;
}
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
</style>
